if(typeof p80 === typeof undefined) {
    var p80 = {};
}

p80.productHistory = function(config) {
    /****
     *
     * USAGE:
     * 
     * Update line 55 with your unique store front access token (unless it has already been defined by the theme in p80.storefrontToken)
     * 
     * const p80History = new p80.productHistory(
     *  {
     *      resultsDisplayed: 4,
     *      targetElement: "your-target-identifier",
     *      title: "Recently Viewed Products",
     *      productId: {current product ID},
     *  }
     * );
     * 
     * REFRESH LIVE:
     * 
     * p80History.getHistory();
     * 
    */


    /****
     * 
     * CONFIGURATION
     * 
     * {
     *      resultsDisplayed: int || 4,
     *      targetElement: string || "product-history",
     *      title: string || "Recently Viewed Products",
     *      productId: int || null,
     * }
     * 
    */
    
    this.config = {};
    // Maximum number of recently viewed products stored 
    // By default this should be one larger than our displayed results - in case our history includes the product we are viewing
    this.config.resultsStored = 5;
    // Maxmium number of recently viewed products displayed
    this.config.resultsDisplayed = config && config.resultsDisplayed ? config.resultsDisplayed : 4;
    // String that holds the title for our recently viewed product area
    this.config.title = config && config.title ? config.title : "Recently Viewed Products",
    // The string identifier for the element we will look to append our markup to
    this.config.targetElement = config && config.targetElement ? config.targetElement : "product-history";
    // The product ID of the current product, used to add to our history stack
    this.config.productId = config && config.productId ? config.productId : null;
    // Name of the cookie where we store our viewed history
    this.config.cookieName = "p80ProductHistory";
    // Our unique store front access token
    this.config.storefrontToken = null;
    if(p80.storefrontToken) {
        this.config.storefrontToken = p80.storefrontToken;
    }
    else if(config && config.storefrontToken) {
        this.config.storefrontToken = config.storefrontToken;
    }

    /****
     * 
     * Data
     * 
    */

    // Holds our product history
    this.productHistory = null;
    // Holds our markup
    this.html = null;
    // Fetch our product history and generate Results
    this.getHistory();
    // Track our product view AFTER history has been fetched - we don't want to show the product the user is currently viewing
    if(this.config.productId) {
        this.addProductView();
    }
}
// Fetch our history data cookie
p80.productHistory.prototype.getHistory = function() {
    let history = this;
    const cookies = document.cookie;
    let cookie = cookies.match(new RegExp('(^| )' + history.config.cookieName + '=([^;]+)'));

    // If we don't have any history data we don't bother generating
    if(!cookie || cookie.length < 1) {
      document.querySelector('.product-recently-viewed-wrapper .title').classList.add('hide');
      return;
    }

    cookie = cookie[2];
    cookie = JSON.parse(cookie);
    
    // Check if our currently viewed product is in our recently viewed list and remove it - we don't want to display the product we're looking at
    const cookieKey = cookie.indexOf(history.config.productId);
    if(cookieKey > -1) {
        cookie.splice(cookieKey, 1);
    }

    // Generate our graphql query to get each variant's information
    let productIds = '';
    for (let i = 0; i < cookie.length; i++) {
        productIds += `"gid://shopify/Product/${cookie[i]}",`
    };
    const graphQuery = `
    {nodes(ids: [${productIds}]){
        ... on Product {
            id
            title
            onlineStoreUrl
            handle
            vendor
            media(first: 1) {
                edges {
                    node {
                        mediaContentType
                        alt
                        ...on MediaImage {
                            image {
                                originalSrc
                                large: transformedSrc(maxWidth: 720)
                                small: transformedSrc(maxWidth: 360)
                            }
                        }
                    }
                }
            }
            priceRange {
            maxVariantPrice {
                amount
            }
            minVariantPrice {
                amount
            }
            }
        }
        }
    }`;

    // Make sure we have products - if not, don't bother making our call
    if(!productIds) {
        return;
    }

    fetch("/api/2021-10/graphql.json", {
        method: "POST", 
        headers: {
            "X-Shopify-Storefront-Access-Token": this.config.storefrontToken,
            "Content-Type": "application/graphql",
        },
        body: graphQuery
    })
    .then(response => response.json())
    .then(data => {
        if(data.data) {
            history.productHistory = data.data.nodes;
            // Filter out null returns
            history.productHistory = history.productHistory.filter(function (el) {
                return el != null;
            });
            history.generate();
        }
    })
    .catch(error => {
        console.log(error)
    });
}
// Generate our markup
p80.productHistory.prototype.generate = function () {
    const history = this;

    const wrapper = document.createElement("div");
    wrapper.classList.add("product-history");

    const title = document.createElement("h3");
    title.classList.add("product-history__title")
    title.textContent = history.config.title;
    wrapper.appendChild(title);

    const productsWrapper = document.createElement("div");
    productsWrapper.classList.add("product-history__wrapper");

    // Loop through our history products
    for(var i = 0; i<history.productHistory.length; i++) {
        // Create our wrapper link
        const product = document.createElement("div");
        
        product.classList.add("product-history__product");

        // Create our product image if it exists
        let productImage;
        if(history.productHistory[i].media.edges.length > 0) {
            productImage = document.createElement("img");
            const imageUrls = history.productHistory[i].media.edges[0].node.image;
            let srcSet = '';
            let imageSizes = '';
            let originalSrc = '';
            for (const url in imageUrls) {
                if(url === "small") {
                    srcSet += `${imageUrls[url]} 360w,`
                    imageSizes += '(max-width: 767px) 360px, ';
                }
                else if(url === "large") {
                    srcSet += `${imageUrls[url]} 720w,`
                    imageSizes += '(min-width: 768px) 720px, '
                }
                else if(url === "originalSrc") {
                    originalSrc = imageUrls[url];
                }
            }
            productImage.setAttribute("loading", "lazy");
            productImage.setAttribute("srcset", srcSet);
            productImage.setAttribute("sizes", imageSizes);
            productImage.src = originalSrc;
            productImage.alt = history.productHistory[i].title;
            productImage.classList.add("product-history__image");
        }
        else {
            productImage = document.createElement("div");
            productImage.classList.add("product-history__image--placeholder");
        }
        
        const productImageWrapper = document.createElement('a');
        productImageWrapper.setAttribute("title", history.productHistory[i].title);
        productImageWrapper.href = `/products/${history.productHistory[i].handle}`;
        productImageWrapper.classList.add('product-history__product-image');
        productImageWrapper.appendChild(productImage);

        // Append the image to our wrapper
        product.appendChild(productImageWrapper);

        // Create our product text content
        const productContent = document.createElement("div");
        
        const vendorAnchor = document.createElement('a');
        const vendorAnchorSpan = document.createElement('span');
        const productAnchor = document.createElement('a');
        const productAnchorSpan = document.createElement('span');

        productContent.classList.add("product-history__content");
        const productVendor = document.createElement('div');
        const productTitle = document.createElement("p");
        
        const productVendorTitle = history.productHistory[i].vendor;
        const productVendorHandle = productVendorTitle.toLowerCase().replace(/[^a-z0-9]/, '').replace(/ /g,'-');

        productTitle.classList.add("product-history__product-title");
        productVendor.classList.add('caption-with-letter-spacing', 'light');
        productVendor.appendChild(vendorAnchor);
        productTitle.appendChild(productAnchor);
        
        vendorAnchor.href = `/collections/${productVendorHandle}`;
        vendorAnchor.setAttribute("title", productVendorTitle);
        vendorAnchor.classList.add('link-border-hover');
        vendorAnchor.appendChild(vendorAnchorSpan);
        vendorAnchor.querySelector('span').textContent = productVendorTitle;

        productAnchor.setAttribute("title", history.productHistory[i].title);
        productAnchor.href = `/products/${history.productHistory[i].handle}`;
        productAnchor.classList.add('link-border-hover');
        productAnchor.appendChild(productAnchorSpan);
        productAnchor.querySelector('span').textContent = history.productHistory[i].title;

        
        productVendor.appendChild(vendorAnchor);
        productContent.appendChild(productVendor);
        productContent.appendChild(productTitle);


        const productPrice = document.createElement("p");
        productPrice.classList.add("product-history__price");
      
        let minPrice = history.productHistory[i].priceRange.minVariantPrice.amount;
        let maxPrice = history.productHistory[i].priceRange.maxVariantPrice.amount;
        if(minPrice) {
          minPrice = parseFloat(minPrice).toFixed(2);
        }
        if(maxPrice) {
          maxPrice = parseFloat(maxPrice).toFixed(2);
        }
        // Display single price display
        if(minPrice === maxPrice) {
            productPrice.textContent = `$ ${minPrice}`;
        }
        // Product has two different prices - show price range
        else {
            const salePrice = document.createElement("span");
            salePrice.classList.add("product-history__product-sale");
            const originalPrice = document.createElement("span");
            originalPrice.classList.add("product-history__product-original");
            salePrice.textContent = `$ ${minPrice} - `;
            originalPrice.textContent = `$ ${maxPrice}`;
            productPrice.appendChild(salePrice);
            productPrice.appendChild(originalPrice);
        }
        productContent.appendChild(productPrice);

        // Append our text content to our product
        product.appendChild(productContent);

        // Append our product to the parent markup
        productsWrapper.appendChild(product);
    }
    // Append all products to our wrapper
    wrapper.appendChild(productsWrapper);
    
    // Assign our markup to our object
    history.html = wrapper;

    history.appendMarkup();
}
// Add our markup to the page
p80.productHistory.prototype.appendMarkup = function() {
    const target = this.findTargetElement();
    if(target) {
        target.innerHTML = '';
        target.appendChild(this.html);
    }
    else {
        console.error(`Unable to find the element identified by ${this.targetElement}`);
    }
}
// Helper function to find our target element for appending markup
p80.productHistory.prototype.findTargetElement = function() {

    /****
     * 
     * Target Finding priority:
     * 
     * ID
     * Class - Taking first result
     * Data Attributes - Taking first result
     * 
    */

    // Find by ID
    let target = document.getElementById(this.config.targetElement);
    // Find by Class
    if(!target) {
        target = document.getElementsByClassName(this.config.targetElement);
        if(target) {
            target = target[0];
        }
    }
    // Find by Attribute
    if(!target) {
        target = document.querySelector(`[${this.config.targetElement}]`);
    }

    // Return our target if found
    return target ? target : null;
}
// Push a product view into our history cookie
p80.productHistory.prototype.addProductView = function () {
    const history = this;
    // We only update our history if we were passed the current product ID
    if(!history.config.productId) {
        return;
    }
    const cookies = document.cookie;
    let cookie = cookies.match(new RegExp('(^| )' + history.config.cookieName + '=([^;]+)'));
    // We have previous history data
    if(cookie && cookie.length > 1) {
        cookie = cookie[2];
        cookie = JSON.parse(cookie);

        // Check if the product already exists in our cookie, remove it if found
        const cookieKey = cookie.indexOf(history.config.productId);
        if(cookieKey > -1) {
            cookie.splice(cookieKey, 1);
        }

        // Add our new product to the front of the array
        cookie.unshift(history.config.productId);
        // If our array is longer than our maximum stored results, delete the last result
        if(cookie.length > history.config.resultsStored) {
            cookie.pop();
        }
        cookie = JSON.stringify(cookie);
        document.cookie = `${history.config.cookieName}=${cookie}; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
    }
    // Wow, no history! Let's initalize a new cookie
    else {
        cookie = [history.config.productId];
        cookie = JSON.stringify(cookie);
        document.cookie = `${history.config.cookieName}=${cookie}; expires=${new Date(new Date().getTime()+1000*60*60*24*365).toGMTString()}; path=/`;
    }
    
}